import { uploadMusic } from '@/api/index'

export default {
  state: {

  },
  mutations: {

  },
  actions: {
    async uploadMusic ({ commit }, { musicName, type, musicUrl, sort }) {
      const res = await uploadMusic({ musicName, type, musicUrl, sort })
      const data = res.data
      if (Number(data.code) === 0) {
        return '成功了！！！！'
      } else {
        return '失败了！！！！'
      }
    }
  }
}
